import React from 'react';

import RelatedRiskIndicator from '../../../RelatedRiskIndicator';

export default (id, label) => ({
	id,
	label,
	propName: 'name',
	width: 'var(--px-75)',
	align: 'center',
	headerAlign: 'center',
	customCell: ({assertions}) => {
		const props = {
			isRiskAssertion: true,
			assertion: assertions.find((assertion) => assertion.assertionAbbreviation === label)
		};

		return <RelatedRiskIndicator {...props} />;
	}
});
